import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';

const StyledSkeleton = styled(Skeleton)`
  height: ${({ theme }) => theme.spacing.values.plusQuarter};
  min-width: ${({ theme }) => theme.spacing.values.double};
`;

export const RowSkeleton = () => (
  <>
    <StyledSkeleton />
    <StyledSkeleton />
  </>
);
